export default __webpack_public_path__ + "static/media/kitAlarma2Mobile.6926ce4b.png";